// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__2qibi","bookingInfo":"TimeRange_bookingInfo__3aEzI","dateSection":"TimeRange_dateSection__nOr4k"};